import React from "react"
import InlineEditText from "../../../common/inline-edit/text.component"
import { FormattedMessage, injectIntl } from "react-intl"

type OwnProps = {
    editable: boolean
    endPoint: string
    field: string
    value: string
    onSave: (value: string) => void
}

const EditProjectTitleComponent = (props: OwnProps) => {

    return (
        <div className={"position-relative mt-2 px-1 text-break col-lg-3 col-md-4"}>
            <div className={"py-1 px-2 h-100 inline-input"}>
                <div>
                    <label className="col-form-label custom-form-label project-details-label pt-0">
                        <FormattedMessage
                            id="order.analytics.project_title_label"
                            defaultMessage="Project Title"
                        />
                    </label>
                </div>
                <div>
                    <InlineEditText
                        editable={props.editable}
                        endPoint={props.endPoint}
                        field={props.field}
                        value={props.value}
                        onSave={(value) => props.onSave(value)}
                    />
                </div>
            </div>
        </div>
    )
}

export default injectIntl(EditProjectTitleComponent)




// WEBPACK FOOTER //
// ./src/quote/project/component/EditProjectTitleComponent.tsx